"use client";

import React, { useEffect } from "react";
import { useSession } from "@/contexts/session";
import { useRedirectToLogin } from "./useRedirectToLogin";

type Props = {
	children: React.ReactNode;
};

function WithAuthentication({ children }: Props) {
	const { hasAuthenticatedSession } = useSession();
	const redirectToLogin = useRedirectToLogin();

	useEffect(() => {
		if (!hasAuthenticatedSession) {
			redirectToLogin();
		}
	}, [hasAuthenticatedSession, redirectToLogin]);

	if (!hasAuthenticatedSession) {
		return null;
	}

	return <>{children}</>;
}

export default WithAuthentication;
